<template>
  <div class="w-full py-2.5 bg-pure-white" :style="{ minHeight: '800px' }">
    <div
      id="template-header"
      class="px-6.5 pb-1 flex items-center justify-between gap-16"
    >
      <div class="flex-shrink-0">
        <div
          v-if="!currentCenter.logo_url"
          class="h-6.5 w-20 border border-slate-400 rounded flex items-center justify-center"
        >
          <div class="text-xxs text-slate-800">Center logo</div>
        </div>
        <img v-else :src="currentCenter.logo_url" alt="logo_url" class="h-6.5" />
      </div>
      <div class="text-right text-xxs text-slate-700 truncate">
        <div class="truncate">{{ client.name }}</div>
        <div>Report for DD/MM/YYYY - DD/MM/YYYY</div>
      </div>
    </div>

    <div
      id="template-title"
      class="px-6.5 h-10 flex items-center justify-center"
    >
      <div class="text-slate-1000 font-bold">Your report title</div>
    </div>

    <div v-if="template !== 'blank'" class="px-6.5 py-0.5">
      <div
        v-if="template === 'selected_curricula_or_target_types'"
        class="text-slate-1000"
      >
        <div class="text-xs font-semibold">Curriculum A</div>
        <div class="text-xs">
          A total of 3 targets are associated with this curriculum.
        </div>
      </div>
      <div v-else class="flex flex-col gap-1">
        <div class="h-2.5 w-full rounded-full bg-slate-400"></div>
        <div class="h-2.5 w-2/3 rounded-full bg-slate-400"></div>
      </div>
    </div>

    <div
      v-if="
        template === 'progress_highlights' || template === 'mastered_targets'
      "
      id="exmaple-cumulative"
    >
      <div class="py-1 flex items-center justify-center text-slate-1000">
        <div class="text-xs font-semibold">Cumulative Graph</div>
      </div>
      <ExampleCumulative class="w-full" />
    </div>

    <div v-if="template !== 'blank'" id="exmaple-target-graph">
      <div
        class="py-1 flex flex-col items-center justify-center text-slate-1000"
      >
        <div class="text-xs font-semibold">Target 1</div>
        <div v-if="template === 'mastered_targets'" class="text-xs">
          Mastered
        </div>
        <div v-else class="text-xs">
          In acquisition
        </div>
      </div>
      <ExampleTargetGraph class="w-full" />
    </div>

    <div
      v-if="template === 'selected_curricula_or_target_types'"
      id="exmaple-target-graph-2"
    >
      <div
        class="py-1 flex flex-col items-center justify-center text-slate-1000"
      >
        <div class="text-xs font-semibold">Target 2</div>
        <div class="text-xs">Mastered</div>
      </div>
      <ExampleTargetGraph2 class="w-full" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExampleCumulative from "./ExampleCumulative.vue";
import ExampleTargetGraph from "./ExampleTargetGraph.vue";
import ExampleTargetGraph2 from "./ExampleTargetGraph2.vue";

export default {
  name: "ReportTemplateExample",
  components: {
    ExampleCumulative,
    ExampleTargetGraph,
    ExampleTargetGraph2
  },
  props: {
    template: { tyep: String, required: true } // progress_highlights | mastered_targets | selected_curricula_or_target_types
    // @close-modal
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentCenter", "client"])
  },
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/clients/report/TemplateExample.vue